import { t } from "i18next";

import {
  Alert,
  type AlertColor,
  AlertTitle,
  type SxProps,
  type Theme,
  Typography
} from "@mui/material";

import { theme } from "@/src/theme/theme";

import { type TargetPriceStatus } from "./targetPriceStatus";

export interface TargetPriceAlertProps {
  status: TargetPriceStatus;
  title?: string;
  description?: string;
  sx?: SxProps<Theme>;
}

const STATUS_SEVERITY: Record<TargetPriceStatus, AlertColor> = {
  within: "success",
  below: "info",
  above: "warning"
};

const getSuccessBackgroundSx = (): SxProps<Theme> => ({
  backgroundColor: (theme) => theme.palette.semantic.success.alertBg
});

const TargetPriceAlert = ({
  status,
  title,
  description,
  sx
}: TargetPriceAlertProps) => {
  const resolvedTitle =
    title ?? t(`components.targetPriceAlert.${status}.title`);
  const resolvedDescription =
    description ?? t(`components.targetPriceAlert.${status}.body`);

  const successSx: SxProps<Theme> =
    status === "within" ? getSuccessBackgroundSx() : {};

  return (
    <Alert
      severity={STATUS_SEVERITY[status]}
      sx={[successSx, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <AlertTitle
        sx={{
          fontWeight: theme.typography.fontWeightBold,
          mb: 0.5
        }}
      >
        {resolvedTitle}
      </AlertTitle>
      <Typography variant="body2">{resolvedDescription}</Typography>
    </Alert>
  );
};

export default TargetPriceAlert;
